<template>
  <NearMe :location="location"/>
</template>
<script setup>
const props = defineProps({
  blok: Object,
});
const route = useRoute();
const location = computed(() => route.params.location);
</script>
